export const convertColorToHex = (color) => {
    switch (color) {
        case 'noir': return '#000000';
        case 'blanc': return '#FFFFFF';
        case 'gris': return '#808080';
        case 'rouge': return '#FF0000';
        case 'vert': return '#00FF00';
        case 'bleu': return '#0000FF';
        case 'jaune': return '#FFFF00';
        case 'orange': return '#FFA500';
        case 'rose': return '#FFC0CB';
        case 'violet': return '#800080';
        case 'marron': return '#8B4513';
        case 'beige': return '#F5F5DC';
        case 'couleur unique': return '#000000';
        default: return color;
    }
}

export const convertStatusToFrench = (status) => {
    switch (status) {
        case 'paid': return 'Payée';
        case 'pending': return 'En attente';
        case 'cancelled': return 'Annulée';
        case 'delivered': return 'Livrée';
        default: return status;
    }
}

export const convertStatusToEnglish = (status) => {
    switch (status) {
        case 'paid': return 'Paid';
        case 'pending': return 'Pending';
        case 'cancelled': return 'Cancelled';
        case 'delivered': return 'Delivered';
        default: return status;
    }
}